export const UPDATE_USER = 'users:updateUser';

export function updateUser(person){
	return {
		type:UPDATE_USER,
		payload:{
			user:person
		}
	}
}